import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, of, tap } from 'rxjs';
import { Brand } from "../models/brand.model";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  private readonly ENDPOINT = '/brand/'
  private cachedBrands: Brand[] | null = null;

  constructor(private http: HttpClient) {
  }

  getBrands(): Observable<Brand[]> {
    if (this.cachedBrands) {
      return of([...this.cachedBrands]);
    }

    const request = this.http.get<Brand[]>(environment.apiUrl + this.ENDPOINT)
      .pipe(tap(brands => {
        this.cachedBrands = [...brands];
      }));

    return request;
  }
}
